import * as React from "react";
import { QueryClient, QueryClientProvider, QueryCache, MutationCache } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import { MainRouter } from "./router";
import { CheckoutProvider } from "./features/checkout";
import { WaitlistModalProvider, EarlyAccessModalProvider } from "./hooks";
import { CREDITS_QUERY_KEY } from "./hooks/useCredits";
import "./index.css";

// Query keys for actions that consume credits
const CREDIT_CONSUMING_QUERY_KEYS = [
  'overviewAnalytics',
  'basicExpectationAnalytics',
  'softSkillsAnalytics',
  'workStyleAnalytics',
  'workplaceQualitiesAnalytics',
  'workMotivatorsAnalytics',
  'personalityAnalytics',
  'domainKnowledgeAnalytics',
  'cvAnalyses',
];

const invalidateCredits = () => {
  if (localStorage.getItem('precisionAccess')) {
    queryClient.invalidateQueries({ queryKey: CREDITS_QUERY_KEY });
  }
};

// Create a client
const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onSuccess: (_data, query) => {
      const key = query.queryKey[0] as string;
      if (CREDIT_CONSUMING_QUERY_KEYS.includes(key)) {
        invalidateCredits();
      }
    },
  }),
  mutationCache: new MutationCache({
    onSuccess: () => {
      invalidateCredits();
    },
  }),
  defaultOptions: {
    queries: {
      retry: 0,
      staleTime: 60 * 1000,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <EarlyAccessModalProvider>
        <WaitlistModalProvider>
          <CheckoutProvider>
            <MainRouter />
          </CheckoutProvider>
          <Toaster position="top-right" richColors />
        </WaitlistModalProvider>
      </EarlyAccessModalProvider>
    </QueryClientProvider>
  );
};

export default App;